import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "overflow-x-auto p-2 -m-2" }
const _hoisted_5 = { class: "text-gray-900 font-medium truncate" }
const _hoisted_6 = { class: "truncate" }

import { computed, onMounted, ref } from 'vue'

import TablistGrid from '@/components/neue/TablistGrid.vue'
import { labelTypeDisplay } from '@/helpers/labelTypes'
import api from '@/store/api'
import { mapType } from '@/store/mappers'

const pageSize = 25


export default {
  __name: 'LabelList',
  setup(__props) {

const labelCols = [{ width: 'minmax(80px, 2fr)' }, { width: 'minmax(80px, 1fr)' }]

const labels = computed(() => mapType('label'))
const loading = ref(true)
const page = ref(0)

const prev = ret => {
  page.value--
  ret()
}
const next = ret => {
  page.value++
  ret()
}

onMounted(() => {
  api.call('GET', 'labels?included=none').then(() => {
    loading.value = false
  })
})

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_NeuePagination = _resolveComponent("NeuePagination")
  const _component_EmptyState = _resolveComponent("EmptyState")
  const _component_NeueWell = _resolveComponent("NeueWell")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")

  return (_openBlock(), _createBlock(_component_SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(_component_SecondaryTop, { text: "Labels" }, {
        right: _withCtx(() => [
          _createVNode(_component_router_link, { to: "/store/labels/new" }, {
            default: _withCtx(() => [
              _createVNode(_component_NeueButton, { type: "primary" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("New", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_NeueLoading, { loading: loading.value }, {
            default: _withCtx(() => [
              (labels.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_NeueTablist, null, {
                        head: _withCtx(() => [
                          _createVNode(_component_TablistHeader, null, {
                            default: _withCtx(() => [
                              _createVNode(TablistGrid, {
                                columns: labelCols,
                                header: ""
                              }, {
                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                  _createElementVNode("div", null, "Name", -1),
                                  _createElementVNode("div", null, "Type", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value.slice(page.value * pageSize, (1 + page.value) * pageSize), (label) => {
                            return (_openBlock(), _createBlock(_component_TablistRow, {
                              key: label.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: '/store/labels/' + label.id,
                                  class: "w-full cursor-pointer"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(TablistGrid, { columns: labelCols }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, _toDisplayString(label.attributes.label_name), 1),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(labelTypeDisplay)(label.attributes.label_type)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_NeuePagination, {
                      size: labels.value.length,
                      from: 1 + page.value * pageSize,
                      to: (1 + page.value) * pageSize,
                      onPrev: prev,
                      onNext: next
                    }, null, 8, ["size", "from", "to"])
                  ]))
                : _createCommentVNode("", true),
              (!labels.value.length)
                ? (_openBlock(), _createBlock(_component_NeueWell, {
                    key: 1,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EmptyState, { plural: "labels" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}